import * as firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyB_QXguMecz4uZr6nqoH93Blp3qumSLZNo",
  authDomain: "tasks-schmuckli.firebaseapp.com",
  databaseURL: "https://tasks-schmuckli.firebaseio.com",
  projectId: "tasks-schmuckli",
  storageBucket: "tasks-schmuckli.appspot.com",
  messagingSenderId: "214287469792",
  appId: "1:214287469792:web:0bf737a0ab01d2300e9485"
};
//Change the credentials also in the service worker file.

var app = firebase.initializeApp(firebaseConfig);

export default app;